import { type HttpPost, type HttpRequest, mapServerError } from '@/shared/infra/http'
import { EsignProviderUnavailableError, WaiverNotMigratedError } from '@/shared/domain'
import type {
  CreateSignatureRequest,
  CreateSignatureRequestParams,
  CreateSignatureRequestResult,
} from '@/modules/auth/use-cases'

type RawCreateSignatureRequestResponse = {
  signatureRequestId?: string
  embeddedSignUrl?: string
  alreadySigned?: boolean
  expiresAt?: string
  templateName?: string
}

export class EdgeCreateSignatureRequestRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: CreateSignatureRequest = async (
    params: CreateSignatureRequestParams,
  ): Promise<CreateSignatureRequestResult> => {
    const request: HttpRequest<CreateSignatureRequestParams> = {
      url: '/signature-requests',
      body: params,
    }
    try {
      const response = await this.httpClient.post<
        CreateSignatureRequestParams,
        RawCreateSignatureRequestResponse
      >(request)
      return mapResponse(response)
    } catch (err) {
      mapServerError(err, {
        '422': WaiverNotMigratedError,
        '502': EsignProviderUnavailableError,
      })
    }
  }
}

function mapResponse(
  response: RawCreateSignatureRequestResponse,
): CreateSignatureRequestResult {
  const raw = response ?? {}
  return {
    signatureRequestId: raw.signatureRequestId ?? undefined,
    embeddedSignUrl: raw.embeddedSignUrl ?? undefined,
    alreadySigned: raw.alreadySigned ?? undefined,
    expiresAt: raw.expiresAt ?? undefined,
    templateName: raw.templateName ?? undefined,
  }
}
